import './ListItemDetails.scss'

import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

import { ButtonAnchor } from 'hb4e-ui-core-ui'
import { CoreURLs } from 'hb4e-ui-core'
import { useAnalytics } from 'hb4e-ui-analytics'

import { getProductDetailsForListItem } from '../../../../../../list-service'
import ListItemActions from './ListItemActions/ListItemActions'
import ListItemProductDetails from '../../../../ListItemProductDetails/ListItemProductDetails'
import { listsPageType } from '../../../../../../constants'

const { urlFreeTrial, urlIDPProduct } = CoreURLs

// Must be used within list-view__list-details in ListView.jsx
const ListItemDetails = ({ item, list }) => {
  // Do not render the item if it does not have any product returned from BE (product may have been removed from catalog or retired)
  if (!item.product) {
    return null
  }

  const {
    productAuthors,
    productAvailabilityID,
    productImage,
    productTitle,
    productType,
    signpost,
    expirationDate,
    isExpired,
  } = getProductDetailsForListItem(item)

  const productURL = urlIDPProduct(productAvailabilityID, {})
  const { trackPageLoad } = useAnalytics()

  const renderListItemActions = () => {
    return (
      <div className="list-item-details__product-actions">
        <ListItemActions item={item} list={list} />
      </div>
    )
  }

  const renderFreeTrialExpirationDate = () => {
    if (!list.isFreeTrialsList()) {
      return null
    }

    return (
      <div className="list-item-details__info-expiration-date">
        <span className="list-item-details__expiration-date-key">Expiration Date: </span>
        <span className="list-item-details__expiration-date-value">{expirationDate}</span>
      </div>
    )
  }

  const renderFreeTrialButton = () => {
    if (!list.isFreeTrialsList()) {
      return null
    }

    return (
      <div className="list-item-details__free-trial-container">
        <ButtonAnchor
          data-testid="list-item-details-free-trial-button"
          theme="outline"
          href={urlFreeTrial(item.product)}
          className="list-item-details__free-trial-button"
          disabled={isExpired}
        >
          {isExpired ? 'This Free Trial has Expired' : 'Resume Free Trial'}
        </ButtonAnchor>
      </div>
    )
  }

  // Analytics logic.
  useEffect(() => {
    trackPageLoad({
      pageType: listsPageType,
      pageName: 'List Details Page',
    })
  }, [])

  return (
    <div className="list-item-details">
      <div className="list-item-details__container">
        <img className="list-item-details__product-image" src={productImage} alt="" />
        <div className="list-item-details__product-type">
          <span className="list-item-details__product-type-category">{productType}</span>
          {signpost && <span className="list-item-details__product-type-signpost">{signpost}</span>}
        </div>
        <h3 className="list-item-details__product-title">
          <Link className="list-item-details__product-title-text" to={productURL}>
            {productTitle}
          </Link>
        </h3>
        <div className="list-item-details__product-authors">{`By: ${productAuthors}`}</div>
        {renderFreeTrialExpirationDate()}
        {renderListItemActions()}

        <div className="list-item-details__additional-details">
          <ListItemProductDetails item={item} />
        </div>

        {renderFreeTrialButton()}
      </div>
    </div>
  )
}

export default ListItemDetails
